module.exports = __webpack_public_path__ + "static/media/open-hour-icon.ef0e0c32.svg";